import type { ExpenseBreakdownItem } from "@/store/expenseSlice";

/** "1,234" / "1234" / "1,234円" / 全角数字 などを数値化。失敗時は null */
export const parseExpenseBreakdownAmount = (input: string): number | null => {
  const compact = input
    .normalize("NFKC")
    .trim()
    .replace(/[,，\s\u3000円￥]/g, "");
  if (compact === "") return 0;
  const amount = Number(compact);
  if (!Number.isFinite(amount) || amount < 0) return null;
  return amount;
};

export const updateExpenseBreakdownAmount = (
  items: ExpenseBreakdownItem[],
  id: string,
  input: string,
): ExpenseBreakdownItem[] | null => {
  const amount = parseExpenseBreakdownAmount(input);
  if (amount === null) return null;
  return items.map((row) => (row.item_id === id ? { ...row, amount } : row));
};
